import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Badge } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getFolderPaths, getGuideList } from '../../../../slices/thunks.js';
import { Link } from 'react-router-dom';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid.js';
import ResiduesList from '../../Residues/ResiduesList.js';
import { setRequireCloseModal, setRequireReloadSelectionItemsGrid } from '../../../../slices/guide/reducer.js';
import ConfirmPrecertificationGuidesModal from './Modals/ConfirmPrecertificationGuideModal.js';
import ConfirmCertificationGuidesModal from './Modals/ConfirmCertificationGuideModal.js.js';
import EditCertificationDataGuideModal from './Modals/EditCertificationDataGuideModal.js';
import GuideDetail from '../../Guides/GuideDetail.js';
import useFileType from '../../../../Components/Hooks/useFileTypeHooks.js';
import useFolderPaths from '../../../../Components/Hooks/useFolderPathsHooks.js';
import { toast } from 'react-toastify';

const CertificationProcessGuide = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorGuides = createSelector(
		state => state.Guides,
		guide => ({
			guideList: guide.guideList,
			isLoadingList: guide.isLoadingList,
			isGuideSuccess: guide.isGuideSuccess,
			error: guide.error,
			isAdding: guide.isAdding,
			isAdded: guide.isAdded,
			isAddError: guide.isAddError,
			isUpdating: guide.isUpdating,
			isUpdated: guide.isUpdated,
			isUpdateError: guide.isUpdateError,
			isDeleting: guide.isDeleting,
			isDeleted: guide.isDeleted,
			isDeleteError: guide.isDeleteError,
			requireCloseModal: guide.requireCloseModal,
			requireReloadSelectionItemsGrid: guide.requireReloadSelectionItemsGrid
		})
	);

	const {
		guideList,
		isLoadingList,
		requireCloseModal,
		requireReloadSelectionItemsGrid
	} = useSelector(selectorGuides);

	useEffect(() => {
		dispatch(getGuideList({
			certified_final_destination: true
		}));
	}, []);

	const [dataGuide, setDataGuide] = useState(null);
	const [isEdit, setIsEdit] = useState(false);

	// Delete Guide
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = guide => {
		setDataGuide(guide);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = guide => {
		setDataGuide(guide);
		handleToggleModal();
	};

	const [guideSelectedList, setGuideSelectedList] = useState([])

	const [selectionProcessList, setSelectionProcessList] = useState([]);
	const [selectionToToProcessedList, setSelectionToToProcessedList] = useState([]);

	function handleRemoveGuideSelectionList(guide) {
		let selectionProcessListToUpdate = selectionProcessList;
		delete selectionProcessListToUpdate[guide._id];
		setSelectionProcessList(selectionProcessListToUpdate);
		setGuideSelectedList(guideSelectedList.filter(item => item._id != guide._id));
	}

	function handlerUpdateGuide(guide) {
		setGuideSelectedList(guideSelectedList.map((item) => {
			if (item._id == guide._id) {
				return { ...item, ...guide };
			} else {
				return item;
			}
		}));
	}

	const [modalGuideDetail, setModalGuideDetail] = useState(false);
	const [selectedGuideId, setSelectedGuideId] = useState(null);
	const toggleModal = () => setModalGuideDetail(!modalGuideDetail);
	const handleGuideClick = (guide) => {
		setSelectedGuideId(guide);
		toggleModal();
	};


	const columnsTableProcess = useMemo(
		() => [
			// {
			// 	header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
			// 	accessorKey: 'guide',
			// 	 size: 'auto',
			// 	Cell: cellProps => {
			// 		return (
			// 			<React.Fragment>
			// 				<div className='d-flex'>
			// 					<div className='flex-shrink-0'>
			// 						<ul className='list-inline mb-0'>
			// 							<li className='list-inline-item'>
			// 								<Link
			// 									to='#'
			// 									className='remove-item-btn'
			// 									onClick={() => {
			// 										const guideData = cellProps.row.original;
			// 										handleClickDelete(guideData);
			// 									}}
			// 								>
			// 									<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
			// 								</Link>
			// 							</li>
			// 							<li className='list-inline-item'>
			// 								<Link
			// 									to='#'
			// 									className='remove-item-btn'
			// 									onClick={() => {
			// 										const guideData = cellProps.row.original;
			// 										handleClickDelete(guideData);
			// 									}}
			// 								>
			// 									<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
			// 								</Link>
			// 							</li>
			// 						</ul>
			// 					</div>
			// 				</div>
			// 			</React.Fragment>
			// 		);
			// 	},
			// },

		{
			header: "Guía",
			accessorKey: "guide_number",

			size: "auto",
			Cell: ({ row }) => {
				const displayNumber = row.original.folio || row.original.guide_number || '-';
				return (
					<span 
						onClick={() => handleGuideClick(row.original)} 
						style={{ cursor: "pointer", color: "var(--vz-primary)", textDecoration: "none", fontWeight: "bold" }}
					>
						{displayNumber}
					</span>
				);
			},
		},
			{ header: 'Fecha', accessorKey: 'guide_date', dataType: 'date' },
			{
				header: 'Estado',
				accessorKey: 'status_final_destination_management',
				size: 'auto',
				Cell: ({ row }) => {
					let status = row.original.status_final_destination_management
					if (!status) {
						return '';
					}
					let bgColor = status.bgcolor;
					let txColor = status.txcolor;
					return (
						<div>
							<span className={`badge`} style={{ backgroundColor: bgColor, color: txColor }}>
								{row.original.status_final_destination_management?.name
									? row.original.status_final_destination_management.name
									: ''}
							</span>
						</div>
					);
				},
			},
			{ header: 'Origen', accessorKey: 'establishment.name', size: 'auto', },
			{ header: 'Destino Final', accessorKey: 'final_destination.name', size: 'auto', },
			{ header: 'Kg Enviados', accessorKey: 'kilograms_sended', size: 'auto' },
			{ header: 'Kg Recibidos', accessorKey: 'kilograms_received', size: 'auto' },
			{ header: 'Kg Certificados', accessorKey: 'kilograms_certified', size: 'auto', Cell: ({ row }) => row.original.kilograms_certified ?? "-", },
			{ header: 'Factura', accessorKey: 'invoce', size: 'auto', visible: false },
			{ header: 'IVA', accessorKey: 'iva', size: 'auto', visible: false },
			{ header: 'Subtotal', accessorKey: 'subtotal', size: 'auto', visible: false },
			{ header: 'Total', accessorKey: 'total', size: 'auto', visible: false },
			{ header: 'Observación', accessorKey: 'observation', size: 'auto', visible: false, },
		],
		[handleClickEdit]
	);

	const columnsTableToToProcessed = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'guide',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const guideData = cellProps.row.original;
													console.log(guideData)
													setDataGuide(guideData);
													handlerToggleEditCertificationDataGuideModal();
												}}
												title='Editar kilogramos'
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const guideData = cellProps.row.original;
													handleRemoveGuideSelectionList(guideData);
												}}
												title='Deseleccionar guía'
											>
												<i className='ri-indeterminate-circle-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
		{
			header: "Guía",
			accessorKey: "guide_number",

			size: "auto",
			Cell: ({ row }) => {
				const displayNumber = row.original.folio || row.original.guide_number || '-';
				return (
					<span 
						onClick={() => handleGuideClick(row.original)} 
						style={{ cursor: "pointer", color: "var(--vz-primary)", textDecoration: "none", fontWeight: "bold" }}
					>
						{displayNumber}
					</span>
				);
			},
		},
			{ header: 'Fecha', accessorKey: 'guide_date', dataType: 'date' },
			{
				header: 'Estado',
				accessorKey: 'status_final_destination_management',
				size: 'auto',
				Cell: ({ row }) => {
					let status = row.original.status_final_destination_management
					let bgColor = status.bgcolor;
					let txColor = status.txcolor;
					return (
						<div>
							<span className={`badge`} style={{ backgroundColor: bgColor, color: txColor }}>
								{row.original.status_final_destination_management?.name
									? row.original.status_final_destination_management.name
									: ''}
							</span>
						</div>
					);
				},
			},
			{ header: 'Origen', accessorKey: 'establishment.name', size: 'auto', },
			// { header: 'Bodega transitoria', accessorKey: 'Est_establishment_id',  size: 'auto', },
			{ header: 'Destino Final', accessorKey: 'final_destination.name', size: 'auto', },
			{ header: 'Kg Enviados', accessorKey: 'kilograms_sended', size: 'auto' },
			{ header: 'Kg Recibidos', accessorKey: 'kilograms_received', size: 'auto' },
			{ header: 'Kg Certificados', accessorKey: 'kilograms_certified', size: 'auto', Cell: ({ row }) => row.original.kilograms_certified ?? "-", },
			{ header: 'IVA', accessorKey: 'iva', size: 'auto', visible: false },
			{ header: 'Subtotal', accessorKey: 'subtotal', size: 'auto', visible: false },
			{ header: 'Total', accessorKey: 'total', size: 'auto', visible: false },
			{ header: 'Observación', accessorKey: 'observation', size: 'auto', visible: false },
		],
		[handleClickEdit]
	);


	const [goToSelectionItemsTable, setGoToSelectionItemsTable] = useState(false);

	const handlerGoToSelectionList = () => {
		setGoToSelectionItemsTable(!goToSelectionItemsTable);
	}

	function checkKilogramsToCertified() {
		const itemsWithoutKilograms = guideSelectedList.filter(
			item => item.kilograms_certified == null
		);

		return (
			itemsWithoutKilograms.length == 0
				? true : false
		)
	}



	function checkEstablishment() {
		const uniqueEstablishments = [...new Set(guideSelectedList
			.filter(item => item.establishment_id != null)
			.map(item => item.establishment_id))];

		return {
			isSingle: uniqueEstablishments.length === 1,
			establishment: uniqueEstablishments.length === 1 ? uniqueEstablishments[0] : null
		};
	}



	const [isOpenEditCertificationDataGuideModal, setIsOpenEditCertificationDataGuideModal] = useState(false);
	const [isOpenConfirmPrecertificationGuidesModal, setIsOpenConfirmPrecertificationGuidesModal] = useState(false);
	const [isOpenConfirmCertificationGuidesModal, setIsOpenConfirmCertificationGuidesModal] = useState(false);

	function handlerToggleEditCertificationDataGuideModal() {
		setIsOpenEditCertificationDataGuideModal(!isOpenEditCertificationDataGuideModal);
	}
	function handlerToggleConfirmPrecertificationGuidesModal() {
		const isOkKilograms = checkKilogramsToCertified();
		if (isOkKilograms) {
			setIsOpenConfirmPrecertificationGuidesModal(!isOpenConfirmPrecertificationGuidesModal);
		} else {
			toast.error(
				'Debe especificar los kilogramos a certificar en todas las guías antes de precertificar.',
				{ autoClose: 4000 }
			);
		}
	}

	function hasValidFolderPaths(paths) {
		return (paths || []).some(
			path => typeof path === 'string' && path.trim().length > 0
		);
	}

	function handlerToggleConfirmCertificationGuidesModal() {
		const isOkKilograms = checkKilogramsToCertified();
		const { isSingle: isOkEstablishment } = checkEstablishment();

		if (!isOkKilograms) {
			toast.error(
				'Debe especificar los kilogramos a certificar en todas las guías antes de certificar.',
				{ autoClose: 4000 }
			);
			return;
		}
		if (!isOkEstablishment) {
			toast.error(
				'Las guías seleccionadas deben pertenecer al mismo establecimiento.',
				{ autoClose: 4000 }
			);
			return;
		}
		if (!hasValidFolderPaths(folderPaths)) {
			toast.error(
				'No se pudieron resolver las carpetas documentales de las guías. Verifique folio o número de guía e intente de nuevo.',
				{ autoClose: 5000 }
			);
			return;
		}
		setIsOpenConfirmCertificationGuidesModal(!isOpenConfirmCertificationGuidesModal);
	}



	// Effect to manage toggle modal by reducer state require
	useEffect(() => {
		if (requireCloseModal) {
			dispatch(setRequireCloseModal(false));
			if (isOpenConfirmCertificationGuidesModal) {
				handlerToggleConfirmCertificationGuidesModal();
			}
			if (isOpenConfirmPrecertificationGuidesModal) {
				handlerToggleConfirmPrecertificationGuidesModal();
			}
		}
	}, [requireCloseModal]);

	// Effect to manage reload grid by reducer state require
	useEffect(() => {
		if (requireReloadSelectionItemsGrid) {
			dispatch(setRequireReloadSelectionItemsGrid(false))
			dispatch(getGuideList({
				certified_final_destination: true
			}));
			setSelectionProcessList({});
			setGuideSelectedList([]);
			setGoToSelectionItemsTable(false);
		}
	}, [requireReloadSelectionItemsGrid]);

	useEffect(() => {
		if (selectionProcessList) {
			let selectionItems = [];
			Object.entries(selectionProcessList).forEach(([key, value]) => {
				if (key != null) {
					selectionItems.push(guideList.find(item => item._id == key));
				}
			})
			setGuideSelectedList(selectionItems);
		}

	}, [selectionProcessList])


	const selector = createSelector(
		state => state.Guides,
		data => ({
			folderPaths: data.folderPaths,
			isLoading: data.isLoading,
			isLoaded: data.isLoaded,
			isError: data.isError
		})
	);

	const { folderPaths } = useSelector(selector);

	useEffect(() => {
		if (guideSelectedList.length > 0) {
			const newGuideIds = guideSelectedList.map(guide => guide._id);

			let _data = {
				"ids": newGuideIds,
				"middle_path": "Medio Ambiente/Residuo"
			}

			if (newGuideIds.length > 0) {
				dispatch(getFolderPaths(_data));
			}

		}
	}, [guideSelectedList]);


	return (
		<React.Fragment>
			<div className='row'>
				<Col lg={12}>
					<div className='card'>
						<div className='card-header border-0'>
							<div className='d-flex align-items-center'>
								<h5 className='card-title mb-0 flex-grow-1'>
									{(goToSelectionItemsTable ? 'Lista de guías seleccionadas' : 'Lista de guías por precertificar/certificar')}
								</h5>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={handlerGoToSelectionList}
											disabled={(guideSelectedList.length || goToSelectionItemsTable && guideSelectedList.length == 0 ? false : true)}
										>
											<i className={`ri-arrow-${(!goToSelectionItemsTable ? 'right' : 'left')}-line label-icon`}></i>{' '}
											{(!goToSelectionItemsTable ? 'Ir a guías seleccionadas' : 'Volver a guías por precertificar/certificar')}
											{!goToSelectionItemsTable ?
												<Badge color="white" pill className='mx-1'>
													<div className='text-primary fw-bold p-0 m-0'>{guideSelectedList.length}</div>
												</Badge>
												:
												null
											}
										</button>
									</div>
								</div>
							</div>
						</div>

						<div className={`p-3 ${(goToSelectionItemsTable ? 'd-none' : '')}`}>
							<ODataGrid
								columns={columnsTableProcess}
								data={guideList || []}
								getRowIdTable={(originalRow) => originalRow._id}
								selectAllMode={'all'}
								selection={{
									rowSelection: selectionProcessList,
									setRowSelection: setSelectionProcessList,
								}}
								isLoadingData={isLoadingList}
							/>
						</div>
						<div className={`p-3 ${(!goToSelectionItemsTable ? 'd-none' : '')}`}>
							<ODataGrid
								columns={columnsTableToToProcessed}
								data={guideSelectedList || []}
								getRowIdTable={(originalRow) => originalRow._id}
							/>
							<div className='w-100 d-flex flex-row-reverse gap-2 my-4'>
								<button
									className='btn btn-label btn-primary'
									onClick={() => handlerToggleConfirmCertificationGuidesModal()}
									disabled={(guideSelectedList.length ? false : true)}
								>
									<i className={`${Icons.check2} label-icon`}></i> Certificar guías
								</button>
								<button
									className='btn btn-label btn-primary'
									onClick={() => handlerToggleConfirmPrecertificationGuidesModal()}
									disabled={(guideSelectedList.length ? false : true)}
								>
									<i className={`${Icons.check} label-icon`}></i> Precertificar guías
								</button>
							</div>
						</div>
					</div>
				</Col>
			</div>
			<ConfirmPrecertificationGuidesModal
				guidesReception={guideSelectedList}
				isOpen={isOpenConfirmPrecertificationGuidesModal}
				handlerToggleModal={handlerToggleConfirmPrecertificationGuidesModal}
			/>
			<ConfirmCertificationGuidesModal
				guidesReception={guideSelectedList}
				isOpen={isOpenConfirmCertificationGuidesModal}
				folders={folderPaths}
				establishmentId={checkEstablishment().establishment}
				handlerToggleModal={handlerToggleConfirmCertificationGuidesModal}
			/>
			<EditCertificationDataGuideModal
				dataGuide={dataGuide}
				isOpen={isOpenEditCertificationDataGuideModal}
				handlerToggleModal={handlerToggleEditCertificationDataGuideModal}
				handlerUpdateGuide={(guide) => {
					handlerUpdateGuide(guide);
				}}
			/>



			{selectedGuideId && (
				<GuideDetail
					info={selectedGuideId}
					isOpen={modalGuideDetail}
					toggle={toggleModal}
				/>
			)}
		</React.Fragment>
	);
};

export default CertificationProcessGuide;